import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {getAuthorizationCredentialSFRA} from '_utils'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

interface SFRAApiProviderProps {
    hostLink: string
}

export const SFRAApiProvider = ({hostLink}: SFRAApiProviderProps) => {
    const {site, locale} = useMultiSite()
    const {customParams} = getConfig()
    const SFRA_BASE_URL = `https://${hostLink}/on/demandware.store`

    const commonHeaders = {
        'Content-Type': 'application/x-www-form-urlencoded',
    }

    const setUrl = ({endpoint, parameters}) => {
        const url = new URL(`${SFRA_BASE_URL}/Sites-${site.id}-Site/${locale.id.replace('-', '_')}${endpoint}`)

        // Add query parameters
        Object.entries({...parameters}).forEach(([key, value]) => {
            if (key && value) {
                url.searchParams.append(key, value)
            }
        })

        return url.toString()
    }

    const setHeaders = (headers = {}) => {
        try {
            /**
             * If passwordStorefront exists in the sandboxCOnfiguration it means that we need to use it
             * in order to be able to call the controller
             */
            if (customParams?.passwordStorefront) {
                return {
                    authorization: getAuthorizationCredentialSFRA(customParams),
                    ...commonHeaders,
                    ...headers,
                }
            } else {
                return {...commonHeaders, ...headers}
            }
        } catch (error) {
            console.error('Error while fetching Token: ', error)
            throw error
        }
    }

    const setBody = (body = {}) => {
        return JSON.stringify(body)
    }

    const handleResponse = async (response) => {
        try {
            if (!response.ok) {
                // handle the error
                throw new Error(`Error in request: ${response.status} `)
            }
            if (response.status === 204) {
                //204: No content response
                return {}
            }
            const data = await response.json()
            return data
        } catch (error) {
            throw new Error(`Error in request: ${error.message}`)
        }
    }

    return {
        setUrl,
        setHeaders,
        setBody,
        handleResponse,
    }
}
